import { isAxiosError } from 'axios';

/**
 * Exception handling helper function for Axios errors.
 *
 * @param {Error | AxiosError} error An error thrown during
 * an axios request.
 *
 * @throws {Error} An error converted to a standard client-side
 * response message.
 */

export const handleAxiosError = (error: unknown) => {
  if (isAxiosError(error)) {
    if (error.response) {
      if (
        error.response.data &&
        typeof error.response.data === 'object' &&
        'reason' in error.response.data &&
        typeof error.response.data.reason === 'string'
      ) {
        throw new Error(error.response.data.reason);
      }

      throw new Error(
        error.response.data ||
          `The request failed with status code: ${error.response.status}`
      );
    }
    if (error.request) {
      throw new Error(
        error.request.statusText ||
          'The request failed due to a network error. Please check your connection and/or your VPN settings and try again.'
      );
    }

    switch (error.message) {
      case 'Network Error': {
        throw new Error(
          'The request failed due to a network error. Please check your connection and/or your VPN settings and try again.'
        );
      }
    }
    throw error;
  }
};
